import { render, staticRenderFns } from "./animate.vue?vue&type=template&id=10e5610a&scoped=true"
import script from "./animate.vue?vue&type=script&lang=js"
export * from "./animate.vue?vue&type=script&lang=js"
import style0 from "./animate.vue?vue&type=style&index=0&id=10e5610a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5610a",
  null
  
)

export default component.exports